import { Button } from 'components/Toolkit/Button/Button';

import type { FiltersModalProps } from 'features/filters/components/FiltersModal/FiltersModal.typed';

import { useFiltersModal } from 'features/filters/components/FiltersModal/FiltersModal.hook';

import {
  StyledFiltersModal,
  ResultsButtonFooter,
  StyledFiltersPanel,
  Content,
  CloseIcon,
} from 'features/filters/components/FiltersModal/FiltersModal.styled';

import { accessibleOnClick } from 'utils/Accessibility';
import { disableScroll, enableScroll } from 'helpers/scroll';
import { DisplayFilters } from 'features/filters/FiltersHOC';

const FiltersModal = (props: FiltersModalProps) => {
  const { adCount, sectionName } = props;

  const { isOpen, askToClose, onClickResultsButton, resultsButtonText } =
    useFiltersModal({ adCount });

  return (
    <StyledFiltersModal
      isOpen={isOpen}
      onRequestClose={askToClose}
      closeTimeoutMS={200}
      overlayClassName="bottom-sheet-overlay"
      onAfterOpen={disableScroll}
      onAfterClose={enableScroll}
    >
      {/* Only render one instance of the filters component on the search results page at a time,
      whether it's the desktop version or this version, based on whether the filters modal
      is open or closed.

      This is to ensure multiple instances of the same component aren't on the page,
      such as the location filter, listening for changes and updating the page twice. */}
      {isOpen && (
        <Content>
          <CloseIcon
            width="16"
            height="16"
            {...accessibleOnClick(askToClose)}
          />
          <StyledFiltersPanel>
            <DisplayFilters sectionName={sectionName} />
          </StyledFiltersPanel>

          <ResultsButtonFooter>
            <Button
              onClick={onClickResultsButton}
              data-testid="sticky_footer_results"
            >
              {resultsButtonText}
            </Button>
          </ResultsButtonFooter>
        </Content>
      )}
    </StyledFiltersModal>
  );
};

export { FiltersModal };
